import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Form, Row, Col, Spinner, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPlus, faSave, faIdCard, faList } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { DarkModeContext } from "../../context/DarkModeContext";
import { getToken } from "../../utils/auth";


const CRMModalCrear = ({ show, onHide, onRecargarTabla }) => {
    const { darkMode } = useContext(DarkModeContext);

    const [loading, setLoading] = useState(false);
    const [listaReglas, setListaReglas] = useState([]);

    const [formData, setFormData] = useState({
        cuit: "",
        nombre: "",
        telefono: "",
        email: "",
        notaInicial: "",
        idRegla: ""
    });

    useEffect(() => {
        if (show) {
            cargarReglas();
            setFormData({ cuit: "", nombre: "", telefono: "", email: "", notaInicial: "", idRegla: "" });
        }
    }, [show]);

    const cargarReglas = async () => {
        const token = getToken();
        try {
            const response = await fetch(process.env.REACT_APP_API_CRM_OBTENER_ACCIONES, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token: token })
            });
            if (response.ok) {
                const data = await response.json();
                setListaReglas(data || []);
            }
        } catch (error) {
            console.error("Error cargando reglas:", error);
            setListaReglas([]);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "cuit") {
            const soloNumeros = value.replace(/[^0-9]/g, "");
            if (soloNumeros.length <= 11) {
                setFormData(prev => ({ ...prev, [name]: soloNumeros }));
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async () => {
        if (!formData.cuit || formData.cuit.length !== 11) {
            return Swal.fire("Atención", "El CUIT debe tener 11 números exactos.", "warning");
        }
        if (!formData.nombre || !formData.telefono || !formData.idRegla) {
            return Swal.fire("Atención", "Por favor completá: Nombre, Teléfono y Estado Inicial.", "warning");
        }

        setLoading(true);
        const token = getToken();

        try {
            const response = await fetch(process.env.REACT_APP_API_CRM_CREAR_PROSPECTO, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    Token: token,
                    Cuit: formData.cuit,
                    Nombre: formData.nombre,
                    Telefono: formData.telefono,
                    Email: formData.email,
                    NotaInicial: formData.notaInicial,
                    IdRegla: parseInt(formData.idRegla)
                }),
            });

            let data;
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.includes("application/json")) {
                data = await response.json();
            } else {
                const text = await response.text();
                data = { mensaje: text || "Ocurrió un error" };
            }

            if (response.ok) {
                Swal.fire("Éxito", "Prospecto creado correctamente", "success");
                if (onRecargarTabla) onRecargarTabla();
                onHide();
            } else {
                Swal.fire("Error", data.mensaje || "Error al procesar", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error de conexión", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered className={darkMode ? "text-dark" : ""}>
            <Modal.Header closeButton style={{ background: "#b4c400", color: "white" }}>
                <Modal.Title>
                    <FontAwesomeIcon icon={faUserPlus} className="me-2" />
                    Nuevo Prospecto
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-bold">CUIT / DNI *</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="cuit"
                                    placeholder="Solo números"
                                    value={formData.cuit}
                                    onChange={handleChange}
                                    autoFocus
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-bold">Nombre Completo *</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="nombre"
                                    placeholder="Ej: Juan Perez"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-bold">Teléfono *</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="telefono"
                                    placeholder="Ej: 11 1234 5678"
                                    value={formData.telefono}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    name="email"
                                    placeholder="cliente@email.com"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label className="fw-bold text-primary">Estado Inicial / Acción *</Form.Label>
                                <Form.Select
                                    name="idRegla"
                                    value={formData.idRegla}
                                    onChange={handleChange}
                                >
                                    <option value="">-- Seleccione acción --</option>
                                    {listaReglas.length > 0 ? (
                                        listaReglas.map((regla) => (
                                            <option key={regla.id} value={regla.id}>
                                                {regla.aliasVista}
                                            </option>
                                        ))
                                    ) : (
                                        <option disabled>Cargando reglas...</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Form.Group className="mb-3">
                        <Form.Label>Nota Inicial</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="notaInicial"
                            placeholder="Detalles..."
                            value={formData.notaInicial}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancelar</Button>
                <Button
                    style={{ backgroundColor: "#b4c400", border: "none" }}
                    onClick={handleSubmit}
                    disabled={loading}
                >
                    {loading ? <Spinner animation="border" size="sm" /> : <><FontAwesomeIcon icon={faSave} className="me-2" /> Guardar</>}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CRMModalCrear;